module.exports = __webpack_public_path__ + "static/media/mail_icon_1.f464bd7f.svg";